module.exports = __webpack_public_path__ + "static/img/rongyu1.3852c41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rongyu1.png
// module id = YVlQ
// module chunks = 1